import { buildColorMap, RadixColorMap } from "@/components/radixColors";
import {
  AiResponseThought,
  AiAgentStep,
  SuggestedReplyToolCall,
} from "@/v2/entities/chain-of-thoughts/ChainOfThoughts.model";

export interface CommentValue {
  externalId: string;
  createdAt: string;
  updatedAt: string;
  authorId: string;
  authorName?: string;
  authorEmail?: string;
  agent: boolean;
  isInternal: boolean;
  body: string;
  rawBody?: string;
  id?: string;
  suggestedReplies: {
    contextExport: unknown[];
    aiResponseThoughts?: AiResponseThought[];
    steps?: AiAgentStep[];
    toolCalls?: SuggestedReplyToolCall[];
  }[];
}

export function buildTranscript(
  comments: CommentValue[],
  defaultColorMap: RadixColorMap = {}
) {
  let unknownAgentIndex = 1;
  let unknownUserIndex = 1;

  const authorNames = new Map<string, string>();
  comments.forEach((comment) => {
    if (authorNames.has(comment.authorId)) {
      return;
    }

    const authorName =
      comment.authorName != null && comment.authorName !== ""
        ? comment.authorName
        : comment.authorEmail != null && comment.authorEmail !== ""
          ? comment.authorEmail
          : `Unknown ${comment.agent ? "Agent" : "User"} ${comment.agent ? unknownAgentIndex++ : unknownUserIndex++
          }`;

    authorNames.set(comment.authorId, authorName);
  });

  const commentsWithAuthorName = comments.map((comment) => ({
    ...comment,
    authorName:
      authorNames.get(comment.authorId) ??
      `Unknown ${comment.agent ? "Agent" : "User"}`,
  }));

  const authorsToColor = {
    ...defaultColorMap,
    ...buildColorMap(
      [...authorNames]
        .map(([_, authorName]) => authorName)
        .filter((authorName) => defaultColorMap[authorName] == null),
      Object.keys(defaultColorMap).length
    ),
  };

  const commentsWithColors = commentsWithAuthorName
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    )
    .map((comment) => {
      return {
        ...comment,
        color: authorsToColor[comment.authorName] ?? "gray",
      };
    });

  return commentsWithColors;
}

const messageTypes = ["public", "internal"] as const;
type MessageType = (typeof messageTypes)[number];

export function isMessageType(value: string): value is MessageType {
  return messageTypes.includes(value as MessageType);
}

export type TicketTranscriptFilterValue = {
  messageType?: MessageType[];
};
